import React, { Component } from 'react';
import { connect } from 'react-redux';

import CompanyChange from './CompanyChange';
import ModalResetSuccess from 'components/UI/Modal/ModalSuccess';
import { ModalDeleteAccount } from '../../components/UI/Modal/ModalDeleteAccount';
import ModalEmailSupportSuccess from 'components/UI/Modal/ModalSuccess';
import TableCards from 'components/UI/TableCards';
import './Settings.scss';
import * as actions from 'actions/index';
import {
  sendEmailSuport,
  closeChangeCompany,
  showChangeCompany,
  closeSentEmailSupport,
  deleteAccount,
} from 'actions/Settings';
import OptionsForOrder from '../../containers/Menu/DefaultMenu/OptionsForOrder';

class Settings extends Component {
  state = {
    message: '',
    openChangeAddress: false,
    openModalDeleteAccount: false,
    isDeleteSuccess: false,
  };

  componentDidMount() {
    this.props.onChangeTitleHeader('Settings');
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.props.onCloseRequestEmailResetPasswordModal();
      this.props.onCloseSentEmailSupport();
    }
  };

  handleForgotPassword = () => {
    this.props.onRequestEmailResetPassword(this.props.userDetails.username);
  };

  handleChangeMessage = evt => {
    this.setState({ message: evt.target.value });
  };

  handleSendMessage = () => {
    let payload = {
      body: this.state.message,
      subject: 'Change Company',
    };
    this.props.onSendEmailSuport(payload);
  };

  handleMenu = (idBusiness, idAddress) => {
    this.props.onFetchingMenu(idBusiness, idAddress);
  };

  showOptionsForOrder = () => {
    return this.props.restaurantsOptions[0].active
      ? this.props.listAddress.length > 0 &&
          !this.props.addresses.some(item => item.forCollection === false)
      : false;
  };

  showCollectionOption = () => {
    return (
      !this.props.addresses.find(address => address.forCollection) &&
      this.props.showCollectionOption
    );
  };

  getInfoAddressForDelivery = parameter => {
    let address = this.props.addresses.find(item => !!!item.forCollection);
    return !!address && !!address[parameter] ? address[parameter] : ' - ';
  };

  handleSelectOptionForOrder = address => {
    this.props.onSelectAddressForOrder([address]);
    this.setState({ openChangeAddress: false });
  };

  handleCreateCustomerDeliveryAddress = async place => {
    await this.props.onCreateCustomerDeliveryAddress(place);
    this.setState({ openChangeAddress: false });
  };

  openModalAddress = () => {
    this.setState({ openChangeAddress: true });
  };

  openModalAccount = () => {
    this.setState({ openModalDeleteAccount: true });
  };

  closeDeleteAccountModal = () => {
    this.setState({ openModalDeleteAccount: false });
  };

  handleDeleteAccount = () => {
    this.props.onDeleteAccount();
    this.setState({ openModalDeleteAccount: false });
    this.setState({ isDeleteSuccess: true });

    setTimeout(() => {
      this.props.onLogout();
    }, 2000);
  };

  handleCloseDeleteAccountSuccess = () => {
    this.setState({ isDeleteSuccess: false });
  };

  render() {
    return (
      <div className="main-content">
        <CompanyChange
          show={this.props.showCompanyChange}
          close={this.props.onCloseChangeCompany}
          handleChangeMessage={this.handleChangeMessage}
          invalid={this.state.message.length < 10}
          sendMessage={this.handleSendMessage}
        />
        <ModalResetSuccess
          showModal={this.props.isSentEmailResetPasswordSuccess}
          message={'Check your email to reset your password.'}
          closeModal={this.props.onCloseRequestEmailResetPasswordModal}
        />
        <ModalEmailSupportSuccess
          showModal={this.props.isSentEmailSupport}
          message={
            'Your message was sent to support. Give us some time to process your request.'
          }
          closeModal={this.props.onCloseSentEmailSupport}
        />
        <div className="list-items settings">
          <form>
            <h2>Personal Information</h2>
            <div className="flex-row personal-info">
              <div className="config-item">
                <label>First Name </label>
                <input
                  disabled
                  value={this.props.userDetails.firstName}
                  type="text"
                  name="name"
                  placeholder="First Name"
                />
              </div>
              <div className="config-item">
                <label> Last Name </label>
                <input
                  disabled
                  value={this.props.userDetails.lastName}
                  type="text"
                  name="last-name"
                  placeholder="Last Name"
                />
              </div>
              <div className="config-item">
                <label> Email </label>
                <input
                  disabled
                  value={this.props.userDetails.username}
                  type="text"
                  name="email"
                  placeholder="Email"
                />
              </div>
            </div>
            <h2>Delivery Address</h2>
            <div className="span">
              <div className="flex-row">
                <div className="config-item w25">
                  <label> Company </label>
                  <input
                    disabled
                    value={this.props.userDetails.businessName}
                    type="text"
                    name="company"
                    placeholder="Company"
                  />
                </div>
                <div className="config-item w55">
                  <label> Address </label>
                  <input
                    disabled
                    value={this.getInfoAddressForDelivery('street')}
                    type="text"
                    name="address"
                    placeholder="Address"
                  />
                </div>
              </div>
              <div className="tool">
                <a
                  onClick={this.openModalAddress}
                  className="modal-a tooltip popup-with-zoom-anim"
                >
                  Change Address?
                </a>
              </div>
              <div className="flex-row">
                <div className="config-item">
                  <label> Zip Code </label>
                  <input
                    disabled
                    value={this.getInfoAddressForDelivery('postalCode')}
                    type="text"
                    name="zipcode"
                    placeholder="Zip Code"
                  />
                </div>
                <div className="config-item">
                  <label> City </label>
                  <input
                    disabled
                    value={this.getInfoAddressForDelivery('city')}
                    type="text"
                    name="city"
                    placeholder="City"
                  />
                </div>
              </div>
              <div className="tool">
                <a
                  onClick={this.props.onShowChangeCompany}
                  className="modal-a tooltip popup-with-zoom-anim"
                >
                  How to change company?
                </a>
              </div>
            </div>
            <div>
              <h2 className="margin-titles">Password</h2>
              <div className="settings-reset-password">
                <a target="_blank" onClick={this.handleForgotPassword}>
                  Reset your Password
                </a>
              </div>

              <h2>Account</h2>
              <div className="settings-reset-password">
                <a target="_blank" onClick={this.openModalAccount}>
                  Delete your account
                </a>
              </div>

              <ModalDeleteAccount
                closeModal={this.closeDeleteAccountModal}
                isOpen={this.state.openModalDeleteAccount}
                onConfirm={this.handleDeleteAccount}
              />

              <ModalResetSuccess
                showModal={this.state.isDeleteSuccess}
                message={'Your account was deleted successfully.'}
                closeModal={this.handleCloseDeleteAccountSuccess}
              />
            </div>
          </form>
          <TableCards />
        </div>
        <OptionsForOrder
          onFetchingMenu={this.handleMenu}
          idBusiness={this.props.userDetails.idBusiness}
          listAddress={this.props.listAddress}
          showModal={this.state.openChangeAddress}
          showCollectionOption={this.showCollectionOption()}
          onToggleCart={this.props.onToggleCart}
          onDeleteAllproductsFromCard={this.props.onDeleteAllproductsFromCard}
          showDeliverAtHomeOption={this.props.showDeliverAtHomeOption}
          selectOptionForOrder={this.handleSelectOptionForOrder}
          createCustomerDeliveryAddress={
            this.handleCreateCustomerDeliveryAddress
          }
          onCartResetState={this.props.onCartResetState}
          onDeleteRestaurantSelected={this.props.onDeleteRestaurantSelected}
          onFetchingRecentlyOrdered={this.props.onFetchingRecentlyOrdered}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    addresses: state.menuReducer.addresses,
    listAddress: state.menuReducer.listAddress,
    restaurantsOptions: state.menuReducer.restaurantsOptions,
    userDetails: state.authenticationReducer.userDetails,
    showCompanyChange: state.settingsReducer.showCompanyChange,
    showCollectionOption: state.menuReducer.showCollectionOption,
    isSentEmailResetPasswordSuccess:
      state.passwordReducer.isRequestSentEmailResetPasswordSuccess,
    isSentEmailSupport: state.settingsReducer.isSentEmailSupport,
    showDeliverAtHomeOption: state.menuReducer.acceptDeliverAtHome,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChangeTitleHeader: titleHeader =>
      dispatch(actions.changeMenuTitleHeader(titleHeader)),
    onShowChangeCompany: () => dispatch(showChangeCompany()),
    onCloseChangeCompany: () => dispatch(closeChangeCompany()),
    onRequestEmailResetPassword: email =>
      dispatch(actions.requestEmailResetPassword(email)),
    onCloseRequestEmailResetPasswordModal: () =>
      dispatch(actions.onCloseRequestEmailResetPasswordModal()),
    onSendEmailSuport: payload => dispatch(sendEmailSuport(payload)),
    onCloseSentEmailSupport: () => dispatch(closeSentEmailSupport()),
    onToggleCart: status => dispatch(actions.toggleCart(status)),
    onDeleteAllproductsFromCard: () =>
      dispatch(actions.deleteAllProductsFromCart()),
    onSelectForColectionOption: () =>
      dispatch(actions.changeRestaurantOptions(2)),
    onSelectAddressForOrder: address =>
      dispatch(actions.selectAddressForOrder(address)),
    onFetchingMenu: (idBusiness, idAddress) =>
      dispatch(actions.fetchingMenu(idBusiness, idAddress)),
    onCreateCustomerDeliveryAddress: place =>
      dispatch(actions.createCustomerDeliveryAddress(place)),
    onCartResetState: () => dispatch(actions.cartResetState()),
    onDeleteRestaurantSelected: () =>
      dispatch(actions.deleteRestaurantSelected()),
    onFetchingRecentlyOrdered: idAddress =>
      dispatch(actions.fetchingRecentlyOrdered(idAddress)),
    onDeleteAccount: () => dispatch(deleteAccount()),
    onLogout: () => dispatch(actions.logoutRequest()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./src/containers/Settings/index.js